/** 门户应用标识 */
export const APP_CODE = {
  ADMIN: 'admin',
  CONSOLE: 'console',
} as const;

export type AppCode = (typeof APP_CODE)[keyof typeof APP_CODE];

export const APP_CODE_LABEL_MAP: Record<AppCode, string> = {
  [APP_CODE.ADMIN]: '管理端',
  [APP_CODE.CONSOLE]: '控制台',
};

/** 下拉选项（角色菜单分配等场景） */
export const APP_CODE_OPTIONS: Array<{ label: string; value: AppCode }> = [
  {
    label: `${APP_CODE_LABEL_MAP[APP_CODE.ADMIN]} (${APP_CODE.ADMIN})`,
    value: APP_CODE.ADMIN,
  },
  {
    label: `${APP_CODE_LABEL_MAP[APP_CODE.CONSOLE]} (${APP_CODE.CONSOLE})`,
    value: APP_CODE.CONSOLE,
  },
];

/** 管理端门户默认 appCode */
export const DEFAULT_ADMIN_PORTAL_APP_CODE = APP_CODE.ADMIN;

/** 控制台门户默认 appCode */
export const DEFAULT_CONSOLE_PORTAL_APP_CODE = APP_CODE.CONSOLE;

export const getAppCodeLabel = (appCode?: string) => {
  if (!appCode) {
    return '-';
  }
  return APP_CODE_LABEL_MAP[appCode as AppCode] || appCode;
};
